module.exports = __webpack_public_path__ + "static/media/survey-sample.59f351ca.png";